module.exports = __webpack_public_path__ + "img/Yaruq-Ali-Khan.03c36b13.jpg";